import { render, staticRenderFns } from "./ExamsModalAlert.vue?vue&type=template&id=413fe426"
import script from "./ExamsModalAlert.vue?vue&type=script&lang=js"
export * from "./ExamsModalAlert.vue?vue&type=script&lang=js"
import style0 from "./ExamsModalAlert.vue?vue&type=style&index=0&id=413fe426&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports